module.exports = __webpack_public_path__ + "img/img3.acac117f.png";